import { ref, getCurrentInstance, onServerPrefetch } from "vue"

export async function useAsyncData(store, key, asyncFn, options = { append: false }) {
  const instance = getCurrentInstance()
  const fetchFn = instance?.appContext.config.globalProperties.$fetchFn
  if (import.meta.env.SSR) {
    onServerPrefetch(async () => {
      const data = await asyncFn(fetchFn)
      store.setData(key, data, options?.append) // 根据 append 决定是否追加
    })
  } else {
    const initialData = store.getData(key)
    if (!initialData) {
      const data = await asyncFn(fetchFn)
      store.setData(key, data, options?.append) // 默认覆盖
    } else {
      if (options?.append) {
        const data = await asyncFn(fetchFn)
        store.setData(key, data, options?.append) // 追加数据
      }
    }
  }
}
